import { render, staticRenderFns } from "./source-sample.vue?vue&type=template&id=3e2c9780&scoped=true&"
import script from "./source-sample.vue?vue&type=script&lang=ts&"
export * from "./source-sample.vue?vue&type=script&lang=ts&"
import style0 from "./source-sample.vue?vue&type=style&index=0&id=3e2c9780&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2c9780",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VDataTable,VDialog,VPagination})
